export default __webpack_public_path__ + "static/1-1724fe15e44c1f842a9ba2cf2896f5ec.png";